import React, { useState, useRef, useEffect } from 'react';
import FacilityCard from './FacilityCard';

const API_URL = '/api/content';

const Facilities = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [facilities, setFacilities] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    fetch(`${API_URL}/facilities`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setFacilities(data);
        }
      })
      .catch(err => console.error('Error fetching facilities:', err));
  }, []);

  useEffect(() => {
    if (facilities.length === 0) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % facilities.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [facilities.length]);

  const getDisplaySlides = () => {
    if (facilities.length === 0) return [];
    const displaySlides = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % facilities.length;
      displaySlides.push(facilities[index]);
    }
    return displaySlides;
  };

  if (facilities.length === 0) return null;

  return (
    <section className="py-20 bg-white">
      {/* Title and Description - Outside the blue section */}
      <div className="container mx-auto px-4 mb-8">
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <div className="flex-1 h-px bg-gray-300"></div>
            <h2 className="text-4xl font-bold text-gray-900 px-8">
              OUR MANUFACTURING FACILITIES
            </h2>
            <div className="flex-1 h-px bg-gray-300"></div>
          </div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            State-of-the-art CNC machining facilities equipped with the latest technology for precision manufacturing.
          </p>
        </div>
      </div>

      {/* Slideshow Container */}
      <div className="py-12">
        <div className="container mx-auto px-4">
          <div className="relative max-w-full mx-auto">
            {/* 3-Column Slideshow */}
            <div 
              ref={containerRef}
              className="relative overflow-hidden"
            >
              <div className="flex gap-6 justify-center">
                {getDisplaySlides().map((slide, index) => (
                  <div key={`${slide.id || index}-${index}`} className="w-[calc(33.333%-16px)] flex-shrink-0">
                    <FacilityCard slide={slide} />
                  </div>
                ))}
              </div>

              {/* Dots Navigation */}
              <div className="flex justify-center gap-2 mt-8">
                {facilities.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`h-3 rounded-full transition-all ${
                      currentSlide === index 
                        ? 'bg-pink-600 w-8' 
                        : 'bg-gray-300 hover:bg-gray-400 w-3'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Facilities;
